import axios from 'axios';
import token from './authToken';

// TEST URL
// const lambUrl = 'https://folqp39skj.execute-api.eu-west-2.amazonaws.com/default/neodisha-fashion-webapp';
// const lambUrl2 = 'http://localhost:7072/api';
const lambUrl2 = 'https://disha-prod.azurewebsites.net/api';

// PROD URL
// const lambUrl = 'https://wfsajq7upd.execute-api.ap-south-1.amazonaws.com/prod/neodisha-fashion-webapp';

export const getInsightPieChart = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_inside_pie_chart`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res.data;
  } catch (error) {
    console.log('Error Calling get insight pie chart API: ', error);
  }
};

export const getInsightKpi = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_user_kpi_711`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res.data;
  } catch (error) {
    console.log('Error Calling get insight kpi API: ', error);
  }
};

export const getBaysCameraView = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_bay_id`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res.data;
  } catch (error) {
    console.log('Error Calling getbaysCameraView API: ', error);
  }
};

export const getBayDetailsCameraView = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_bay_details`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res.data;
  } catch (error) {
    console.log('Error Calling getbaysDetailsCameraView API: ', error);
  }
};

export const GetAllKpi711 = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_all_kpi_data`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res.data;
  } catch (error) {
    console.log('Error Calling GetAllKpi711 API: ', error);
  }
};

export const MarkIgnored = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/markIgnore`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res.data;
  } catch (error) {
    console.log('Error Calling GetAllKpi711 API: ', error);
  }
};

export const MarkSolved = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/markSolved`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res.data;
  } catch (error) {
    console.log('Error Calling GetAllKpi711 API: ', error);
  }
};

export const UploadLayoutImageUrl = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/layout_image_upload`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res.data;
  } catch (error) {
    console.log('Error Calling UploadlayoutimageUrl API: ', error);
  }
};

export const GetBaysWithImagePagination = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_bays_with_image_pagination`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res.data;
  } catch (error) {
    console.log('Error Calling GetBaysWithImagePagination API: ', error);
  }
};

export const CreateStoreConfig = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/create_store_config`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling CreateStoreConfig API: ', error);
  }
};

export const CreateVmConfig = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/create_vm_config`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling CreateVmConfig API: ', error);
  }
};

export const GenerateVmReferenceImageUploadUrl = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/vm_refrence_image`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GenerateVmReferenceImageUploadUrl API: ', error);
  }
};

export const GetStoreOSA = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_store_osa`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetStoreOSA API: ', error);
  }
};

export const GetBayDetails = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_bay_details`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetBayDetails API: ', error);
  }
};

export const GetStoreAnomaly = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_store_anomaly`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetStoreAnomaly API: ', error);
  }
};

export const GetStoreGraph = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_store_graph`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetStoreGraph API: ', error);
  }
};

export const GetBaysByStoreId = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_bay_id`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetBaysByStoreId API: ', error);
  }
};

export const GetCaptureProgress = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_inside_store_capture_progress`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetCaptureProgress API: ', error);
  }
};

export const GetStoreOverviewLayout = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/store_overview_layout`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling store overview layout API: ', error);
  }
};

export const GetUsersForStore = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_user_details_single_store/v1`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetUsersForStore API: ', error);
  }
};

export const UserConfigCreation = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/assignBays/v1`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling UserConfigCreation API: ', error);
  }
};

export const BaysForSingleStore = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/getBays_single_store`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling UserConfigCreation API: ', error);
  }
};

export const GetBaysImageData = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_bays_image_data`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling bays image data API: ', error);
  }
};

export const UpdateBayCoordinates = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/update_bay_coordinates`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling bays image data API: ', error);
  }
};

export const DeleteBays = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/delete_bays`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling bays image data API: ', error);
  }
};

export const GetAllCategories = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_all_categories`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling bays image data API: ', error);
  }
};

export const GetAllFixtures = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_all_fixtures`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling bays image data API: ', error);
  }
};

export const CreateNewBays = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/create_new_bays`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling bays image data API: ', error);
  }
};

export const GetSevenDaysCapProgress = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/store-view/get_seven_days_cap_progress`, data, {
      headers: {
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetCaptureProgress API: ', error);
  }
};

export const GetSevenDaysOSA = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/store-view/get_baywise_osa_seven_days`, data, {
      headers: {
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetCaptureProgress API: ', error);
  }
};

export const GetAssociateScore = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_associate_score`, data, {
      headers: {
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetAssociateScore API: ', error);
  }
};

export const GetCategoryWiseAnomaly = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/store-view/get_baywise_category_anomaly`, data, {
      headers: {
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetCaptureProgress API: ', error);
  }
};

export const UploadStoreData = async (data) => {
  try {
    const res = await axios.post(
      `https://folqp39skj.execute-api.eu-west-2.amazonaws.com/default/neodisha-fashion-webapp/upload_images`,
      data,
      {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      }
    );
    return res;
  } catch (error) {
    console.log('Error Calling UploadStoreData API: ', error);
  }
};

export const UploadEditStoreData = async (data) => {
  try {
    const res = await axios.put(`http://localhost:8081/data/updatestore/6640c3acfa31683c6888738d`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling UploadEditStoreData API: ', error);
  }
};

export const GetStoreData = async (data) => {
  try {
    const res = await axios.post(`http://localhost:8081/data/getstore`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetStoreData API: ', error);
  }
};

// export const dates = async (data) => {
//   try {
//     const res = await axios.post(`${lambUrl}/store/calender`, data, {
//       headers: {
//         Accept: 'application/json',
//         Authorization: await token()
//       }
//     });
//     return res;
//   } catch (error) {
//     console.log('Error Calling Event dates API: ', error);
//   }
// };

export const dates = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_calendar_data/v1`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling Event dates API: ', error);
  }
};

export const GetBrandDonutData = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard/doughtnut/brand_wise_fullness`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetBrandDonutData API: ', error);
  }
};

export const GetFullnessKpi = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard_card_fullness`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    console.log('fullness res', res);
    return res;
  } catch (error) {
    console.log('Error Calling GetFullnessKpi API: ', error);
  }
};

export const GetAnomaliesKpi = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard/card_anomalies`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    console.log('anomaliesData', res);
    return res;
  } catch (error) {
    console.log('Error Calling GetAnomaliesKpi API: ', error);
  }
};

export const GetAnomaliesBarChartData = async (data) => {
  try {
    console.log('adft', data);
    const res = await axios.post(`${lambUrl}/dashboard/anomalies_barchart`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetAnomaliesKpi API: ', error);
  }
};

// API FOR THE LAYOUT OF THE STORE
export const GetStoreLayout = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/store/analysis`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    console.log('api response', res);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};
// API FOR THE LAYOUT OF THE STORE
export const GetImagesFromSignedUrl = async (data) => {
  try {
    const res = await axios.post(`https://wfsajq7upd.execute-api.ap-south-1.amazonaws.com/prod/neodisha-fashion-app/signed_image`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    // console.log("api image response", res);
    return res;
  } catch (error) {
    console.log('Error Calling all Store API: ', error);
  }
};

export const getUsers = async (data) => {
  try {
    const res = await axios.post(
      // `https://folqp39skj.execute-api.eu-west-2.amazonaws.com/default/neodisha-fashion-webapp/team/getalluser`,
      `${lambUrl}/team/getalluser`,
      data,
      {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      }
    );
    // console.log("api image response", res);
    return res;
  } catch (error) {
    console.log('Error while calling team API :', error);
  }
};

export const getOneUser = async (id) => {
  try {
    const res = await axios.get(`${lambUrl}/team/get_one_user?userID=${id}`, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    // console.log("api image response", res);
    return res;
  } catch (error) {
    console.log('Error while calling team api :', error);
  }
};

export const deleteUser = async (id) => {
  try {
    const res = await axios.get(
      `https://folqp39skj.execute-api.eu-west-2.amazonaws.com/default/neodisha-fashion-webapp/team/delete_user?userID=${id}`,
      {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      }
    );
    // console.log("api image response", res);
    return res;
  } catch (error) {
    console.log('Error while calling team api :', error);
  }
};

export const updateUser = async (id, user) => {
  try {
    const res = await axios.post(`${lambUrl}/team/update_user?userID=${id}`, user, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    // console.log("api image response", res);
    return res;
  } catch (error) {
    console.log('Error while calling team api :', error);
  }
};

export const createUser = async (user) => {
  try {
    const res = await axios.post(
      `https://folqp39skj.execute-api.eu-west-2.amazonaws.com/default/neodisha-fashion-webapp/team/create`,
      user,
      {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      }
    );
    // console.log("api image response", res);
    return res;
  } catch (error) {
    console.log('Error while calling team api :', error);
  }
};

export const GetVerifiedUsers = async (phoneNumber) => {
  try {
    const res = await axios.get(`${lambUrl2}/azure/login?numbers=${phoneNumber}`, {
      headers: {
        Accept: 'application/json'
      }
    });
    return res.data;
  } catch (error) {
    console.log('Error Calling users API: ', error);
  }
};

export const GetVMCompliance = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard/vmc_fullness`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetVMCompliance API: ', error);
  }
};

export const GetVMComplianceForOneWeek = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard/timeseries_vmc`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    console.log('result', res);
    return res;
  } catch (error) {
    console.log('Error calling vm compliance for a week api', error);
  }
};

export const GetFullnessForOneWeek = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard/timeseries_fullness`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error calling fullness for a week api', error);
  }
};

export const GetAnomalyDetails = async (data) => {
  try {
    const res = await axios.get(`${lambUrl12}/store/get_analysis_data?analysisID=${data}`, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetAnomalyDetails API: ', error);
  }
};

export const GetAnomaliesForOneWeek = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard/timeseries_anomalies`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error calling anomalies for a week api', error);
  }
};

export const checkId = async (user_id) => {
  try {
    const res = await axios.get(`${lambUrl}/team/check_users?user_id=${user_id}`, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res.data;
  } catch (error) {
    console.log('Error');
    throw error;
  }
};

export const allStoresId = async () => {
  try {
    const res = await axios.get(
      `https://wfsajq7upd.execute-api.ap-south-1.amazonaws.com/prod/neodisha-fashion-webapp/store/get_all_store`,
      {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      }
    );
    return res.data;
  } catch (error) {
    console.log('Error occured');
    throw error;
  }
};

export const GetBarChartData = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_inside_graph`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    console.log('bar chart data', res);
    return res.data;
  } catch (error) {
    console.log('Error calling bar chart api', error);
  }
};

export const GetVMscoreBar = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard/vmc-barchart`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    console.log('vmc data', res);
    return res;
  } catch (error) {
    console.log('Error calling bar chart api', error);
  }
};

export const GetStoreWiseInfo = async (date, store_id) => {
  try {
    const res = await axios.get(`${lambUrl}/store/stores_wise_config?date=${date}&store_id=${store_id}`, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    console.log('hhh', res);
    return res;
  } catch (error) {
    console.log('Error calling store wise info', error);
  }
};
export const GetAllStoresInfo = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/getStoreDetails/v1`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error calling store wise info', error);
  }
};
export const GetBayWiseDetails = async (date, store) => {
  try {
    const res = await axios.get(`${lambUrl}/store/bay_wise_config?date=${date}&store_id=${store}`, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling bay wise details API: ', error);
  }
};

export const GetShelfWiseDetails = async (date, bay_id) => {
  try {
    const res = await axios.get(`${lambUrl}/store/shelf_wise_config?date=${date}&bay_id=${bay_id}`, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    console.log('API response from the api function:', res);
    return res;
  } catch (error) {
    console.log('Error calling shelf-wise details', error);
  }
};

export const GetPartsWiseDetails = async (date, shelf_id) => {
  try {
    const res = await axios.get(`${lambUrl}/store/parts_wise_config?date=${date}&shelf_id=${shelf_id}`, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error calling parts-wise details', error);
  }
};

export const UpdateMetadataStatus = async (id, comments, user_id, solved_time) => {
  try {
    const res = await axios.post(
      `${lambUrl}/store/update`,
      {
        id,
        comments,
        user_id,
        solved_time
      },

      {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      }
    );
    console.log('api image response', res);
    return res;
  } catch (error) {
    console.log('Error while calling team api :', error);
  }
};

export const UpdateMetadataStatusIgnore = async (id, ignored, user_id, ignored_time) => {
  try {
    const res = await axios.post(
      `${lambUrl}/store/update_ignored`,
      {
        id,
        ignored,
        user_id,
        ignored_time
      },

      {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      }
    );
    console.log('api image response', res);
    return res;
  } catch (error) {
    console.log('Error while calling team api :', error);
  }
};

export const SendAlert = async (data, apiKey, apiUrl) => {
  console.log('SendAlert', data);
  try {
    const response = await axios.post(apiUrl, data, {
      headers: {
        Authorization: `Bearer ${apiKey}`
      }
    });

    console.log('API Call Successful (Aisensy):', response.data);
    return true;
  } catch (error) {
    console.error('API Call Failed:', error.message);
    return false;
  }
};

export const GetNeodishaVerifiedUser = async (data) => {
  try {
    const res = await axios.post(
      'https://wfsajq7upd.execute-api.ap-south-1.amazonaws.com/prod/neodisha-fashion-webapp/get-user-detail-beauty',
      data,
      {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      }
    );
    return res;
  } catch (error) {
    console.log('Error calling neodisha verified user', error);
  }
};

export const GetClusterManager = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard_get_cluster_managers`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    // console.log('datasss', res.data);
    return res;
  } catch (error) {
    console.log('Error calling neodisha cluster manager', error);
  }
};

export const GetZones = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard_get_zone`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    // console.log('datasss2', res.data);
    return res;
  } catch (error) {
    console.log('Error calling neodisha cluster manager', error);
  }
};

export const GetStates = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard_get_state`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    // console.log('datasss3', res.data);
    return res;
  } catch (error) {
    console.log('Error calling neodisha cluster manager', error);
  }
};

export const GetCities = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard_get_cities`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    // console.log('datasss4', res.data);
    return res;
  } catch (error) {
    console.log('Error calling neodisha cluster manager', error);
  }
};

export const GetBrands = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/dashboard_get_brands`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    // console.log('datasss5', res.data);
    return res;
  } catch (error) {
    console.log('Error calling neodisha cluster manager', error);
  }
};

export const GetPartAndAnalysisData = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/store/update-reference-img`, data, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: await token()
      }
    });

    return res.data;
  } catch (error) {
    console.error('Error calling getPartAndAnalysisData API:', error);
  }
};

export const GetBayWiseAnomalies = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/store-view/get_baywise_anomaly`, data, {
      headers: {
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetCaptureProgress API: ', error);
  }
};

export const GetBayWiseOSA = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/store-view/get_baywise_osa`, data, {
      headers: {
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetCaptureProgress API: ', error);
  }
};

export const GetBayWiseVM = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/store-view/get_baywise_vm`, data, {
      headers: {
        Accept: 'application/json'
        // Authorization: await token()
      }
    });
    return res;
  } catch (error) {
    console.log('Error Calling GetCaptureProgress API: ', error);
  }
};
export const GetOsaForAll = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_inside_Osa`, data, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: await token()
      }
    });

    return res.data;
  } catch (error) {
    console.error('Error calling getPartAndAnalysisData API:', error);
  }
};
export const GetVmForAll = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_inside_Vm`, data, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: await token()
      }
    });

    return res.data;
  } catch (error) {
    console.error('Error calling getPartAndAnalysisData API:', error);
  }
};

export const GetAnomalyForAll = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/azure/get_inside_anomaly`, data, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: await token()
      }
    });

    return res.data;
  } catch (error) {
    console.error('Error calling getPartAndAnalysisData API:', error);
  }
};

export const getReference = async (dates, ids) => {
  try {
    const data = {
      dates: dates,
      ids: ids
    };
    const res = await axios.post(`${lambUrl}/store/shelf_reference_image`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res.data;
  } catch (error) {
    throw new Error(`Error Calling GetCaptureProgress API: ${error.message}`);
  }
};
export const UploadBulkUser = async (data) => {
  try {
    const res = await axios.post(
      `https://folqp39skj.execute-api.eu-west-2.amazonaws.com/default/neodisha-fashion-webapp/team/bulk_user_upload`,
      data,
      {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      }
    );
    return res;
  } catch (error) {
    throw new Error(`Error Calling GetCaptureProgress API: ${error.message}`);
  }
};
export const ExportStoreData = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/store/store-export-analysis`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res.data;
  } catch (error) {
    throw new Error(`Error Calling GetCaptureProgress API: ${error.message}`);
  }
};
export const ExportBrandReferenceData = async (data) => {
  try {
    const res = await axios.post(`${lambUrl2}/store/report/brand_reference`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res.data;
  } catch (error) {
    throw new Error(`Error Calling GetCaptureProgress API: ${error.message}`);
  }
};

export const ExportUserData = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/team/export-analysis`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res.data;
  } catch (error) {
    throw new Error(`Error Calling GetCaptureProgress API: ${error.message}`);
  }
};
export const getAnomalyBays = async (data) => {
  try {
    const res = await axios.post(
      `https://folqp39skj.execute-api.eu-west-2.amazonaws.com/default/neodisha-fashion-app/dashboard/get-anomaly-bay`,
      data,
      {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      }
    );
    return res.data;
  } catch (error) {
    throw new Error(`Error Calling getAnomalyBays API: ${error.message}`);
  }
};
export const getBayAnomalyList = async (data) => {
  try {
    const res = await axios.post(
      ` https://folqp39skj.execute-api.eu-west-2.amazonaws.com/default/neodisha-fashion-app/dashboard/get-baywise-anomaly-list`,
      data,
      {
        headers: {
          Accept: 'application/json',
          Authorization: await token()
        }
      }
    );
    return res.data;
  } catch (error) {
    throw new Error(`Error Calling getAnomalyBays API: ${error.message}`);
  }
};

export const SetReferenceImageForStore = async (data) => {
  try {
    const res = await axios.post(`${lambUrl}/store/store-reference-img`, data, {
      headers: {
        Accept: 'application/json',
        Authorization: await token()
      }
    });
    return res.data;
  } catch (error) {
    throw new Error(`Error Calling GetCaptureProgress API: ${error.message}`);
  }
};
